// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsbFilledSvg from "@ant-design/icons-svg/es/asn/UsbFilled";
import AntdIcon from '../components/AntdIcon';

var UsbFilled = function UsbFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsbFilledSvg
  }));
};

UsbFilled.displayName = 'UsbFilled';
export default React.forwardRef(UsbFilled);